<div class="backdrop"></div>
<div class="alert-box">
  <p [innerHtml]="message"></p>
  <div class="alert-box-actions">
    <button type="button" class="primary_green_btn" (click)="onClose()">
      OK
    </button>
  </div>
</div>
